export const isNullableOrEmptyString = (
  x: unknown,
): x is null | undefined | '' => x === undefined || x === null || x === '';
